import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'
import './PercentageSlider.scss'
import styles from './PercentageSlider.module.scss'

const PercentageSlider = ({ onChange, value, step }) => {
  const [localValue, setLocalValue] = useState(value)

  useEffect(() => {
    setLocalValue(value)
  }, [value])

  return (
    <div className={styles.wrapper}>
      <InputRange
        formatLabel={currentValue => `${Math.round(currentValue)}%`}
        value={localValue}
        onChange={setLocalValue}
        onChangeComplete={onChange}
        minValue={0}
        maxValue={100}
        step={step}
      />
    </div>
  )
}

PercentageSlider.propTypes = {
  onChange: PropTypes.func.isRequired,
  step: PropTypes.number,
  value: PropTypes.number.isRequired,
}

PercentageSlider.defaultProps = {
  step: 1,
}

export default React.memo(PercentageSlider)
